"use client";

import { Search } from "lucide-react";
import { useShell } from "./ShellProvider";
import { useUi } from "@/components/ui/use-ui";

export function SearchButton() {
  const t = useUi();
  const { openSearch } = useShell();
  return (
    <button
      type="button"
      aria-label={t.nav.search}
      aria-keyshortcuts="/"
      onClick={openSearch}
      className="grid size-11 place-items-center rounded-full text-fg transition-colors hover:bg-white/10"
    >
      <Search size={24} strokeWidth={1.6} />
    </button>
  );
}
